import fetchWithAuth from './fetchWithAuth.ts';
import { apiConfig } from '../config.js';

export async function fetchIngredientSuggestions(q) {
  if (!q || q.length < 2) return [];
  const resp = await fetchWithAuth(
    `/api/ingredients/autocomplete?q=${encodeURIComponent(q)}`
  );
  return await resp; // [{ id, nameCanonical, synonyms, unitDefault, ... }, …]
}
